import { render, staticRenderFns } from "./PecEditor.vue?vue&type=template&id=178faf74"
import script from "./PecEditor.vue?vue&type=script&lang=js"
export * from "./PecEditor.vue?vue&type=script&lang=js"
import style0 from "./PecEditor.vue?vue&type=style&index=0&id=178faf74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports